module.exports = __webpack_public_path__ + "img/A250_S_WS_001_2048x2048.4897f9aa.png";